import { BusinessOutlinedIcon, Text } from '@shared/components';

export function EmptyState() {
  return (
    <>
      <BusinessOutlinedIcon sx={{ fontSize: 48, color: (theme) => theme.palette.grey[500] }} />
      <Text variant='body1Semibold'>ไม่มีห้องสอบที่สามารถเลือกได้</Text>
      <Text variant='body2'>
        ห้องสอบในสถานที่นี้ถูกใช้ในรอบสอบอื่นแล้ว กรุณาเลือกสถานที่อื่น หรือเปลี่ยนวันสอบ
      </Text>
    </>
  );
}
